<div class="service-work-page">
  <div class="service-work-page-content">
    <div class="service-work-page-content__icon">
      <fr8bot-ui-icon name="emoji-bad-32" [size]="50" />
    </div>

    <div class="service-work-page-content__text">
      <h1 class="service-work-page-content__text-title">
        {{ 'common.serviceWorkPage.title' | translate }}
      </h1>
      <h2 class="service-work-page-content__text-description">
        {{ 'common.serviceWorkPage.description' | translate }}
      </h2>
      <h3
        class="service-work-page-content__text-description service-work-page-content__text-description--margin"
      >
        {{ 'common.serviceWorkPage.tryAgain' | translate }}.
      </h3>
    </div>

    <fr8bot-ui-button
      type="primaryCut"
      [disabled]="isChecking()"
      (click)="handlePing()"
      class="service-work-page-content__button"
    >
      {{ 'common.serviceWorkPage.retry' | translate }}

      @if (isChecking()) {
        <fr8bot-ui-loading postfix-icon [delayMs]="0" mode="inline" />
      }
    </fr8bot-ui-button>
  </div>
</div>
